import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SparkleEffect } from '../../components/SparkleEffect';
import { GlitterHeart } from '../../components/GlitterHeart';
import { ArrowRightIcon, SparklesIcon, Gamepad2Icon, HeartIcon, CalendarIcon } from 'lucide-react';
export function AppsHubPage() {
  return <div className="min-h-screen bg-gradient-to-b from-sky-50 via-lavender-50 to-blush-50 pt-28 pb-24 overflow-hidden" data-id="element-689">
      <SparkleEffect count={120} data-id="element-690" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-691">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-16" data-id="element-692">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/80 backdrop-blur-sm border border-plum-200 text-sm font-bold text-plum-700 mb-6 shadow-sm uppercase tracking-wider" data-id="element-693">
            <SparklesIcon className="w-4 h-4 text-cta-500" data-id="element-694" />
            The Digital Universe
          </div>
          <h1 className="font-heading text-5xl md:text-7xl font-bold text-plum-800 mb-6" data-id="element-695">
            The Trippin' <span className="shimmer-text" data-id="element-696">Apps</span>
          </h1>
          <p className="text-xl text-plum-500 max-w-2xl mx-auto font-medium" data-id="element-697">
            From managing the chaos of daily life to sparking real, unfiltered
            connections. Welcome to the digital extension of Mandy's universe.
          </p>
        </motion.div>

        {/* Apps Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-698">
          {/* Trippin' Through Life */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="group relative bg-white rounded-[2.5rem] p-8 shadow-xl border border-blush-100 overflow-hidden flex flex-col hover:-translate-y-2 transition-transform duration-500" data-id="element-699">
            <div className="absolute top-0 right-0 w-64 h-64 bg-blush-100 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 opacity-50" data-id="element-700" />

            <div className="relative z-10 mb-6" data-id="element-701">
              <div className="flex justify-between items-start mb-6" data-id="element-702">
                <div className="w-16 h-16 rounded-2xl bg-blush-50 flex items-center justify-center shadow-sm border border-blush-100" data-id="element-703">
                  <img src="https://cdn.magicpatterns.com/uploads/gieTJfs2YUH6aZyKV1oyEk/ChatGPT_Image_May_11,_2026,_01_53_32_PM.png" alt="TTL Logo" className="w-12 h-12 object-contain" data-id="element-704" />
                </div>
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-100 text-emerald-700 text-xs font-bold uppercase tracking-wider" data-id="element-705">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" data-id="element-706" />
                  Live on Google Play
                </span>
              </div>

              <h3 className="font-heading text-2xl font-bold text-plum-800 mb-3" data-id="element-707">
                Trippin' Through Life
              </h3>
              <p className="text-plum-500 font-medium leading-relaxed mb-8" data-id="element-708">
                Your AI-powered life, home, and wellness management system
                designed to reduce overwhelm and build routines without burnout.
                Now on Google Play — coming soon to the App Store.
              </p>
            </div>

            <Link to="/apps/trippin-through-life" className="relative z-10 mt-auto inline-flex items-center justify-center w-full py-4 rounded-2xl bg-blush-50 text-plum-700 font-bold hover:bg-blush-100 transition-colors group-hover:bg-plum-700 group-hover:text-white" data-id="element-709">
              Explore App
              <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-710" />
            </Link>
          </motion.div>

          {/* Inner Intentions */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="group relative bg-[#0a0014] rounded-[2.5rem] p-8 shadow-2xl border border-fuchsia-900/50 overflow-hidden flex flex-col hover:-translate-y-2 transition-transform duration-500" data-id="element-711">
            <div className="absolute top-0 right-0 w-64 h-64 bg-fuchsia-600/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-712" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-pink-600/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/3" data-id="element-713" />

            <div className="relative z-10 mb-6" data-id="element-714">
              <div className="flex justify-between items-start mb-6" data-id="element-715">
                <div className="w-16 h-16 rounded-2xl bg-black/50 flex items-center justify-center shadow-[0_0_15px_rgba(219,39,119,0.3)] border border-fuchsia-500/30" data-id="element-716">
                  <img src="https://cdn.magicpatterns.com/uploads/hJ4WPpi2ZC6Jbgi4km7R7P/ChatGPT_Image_May_11,_2026,_06_59_04_PM.png" alt="Inner Intentions Logo" className="w-12 h-12 object-contain drop-shadow-[0_0_8px_rgba(236,72,153,0.8)]" data-id="element-717" />
                </div>
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-fuchsia-500/20 text-fuchsia-300 text-xs font-bold uppercase tracking-wider border border-fuchsia-500/30" data-id="element-718">
                  <ClockIcon className="w-3 h-3" data-id="element-719" />
                  Coming Soon
                </span>
              </div>

              <h3 className="font-heading text-2xl font-bold text-white mb-3 drop-shadow-[0_0_10px_rgba(236,72,153,0.5)]" data-id="element-720">
                Inner Intentions
              </h3>
              <p className="text-fuchsia-200/70 font-medium leading-relaxed mb-8" data-id="element-721">
                A social conversation and self-discovery game designed to spark
                real connections, meaningful conversations, and unforgettable
                moments.
              </p>
            </div>

            <Link to="/apps/inner-intentions" className="relative z-10 mt-auto inline-flex items-center justify-center w-full py-4 rounded-2xl bg-fuchsia-950/50 text-fuchsia-300 font-bold hover:bg-fuchsia-900/80 transition-colors border border-fuchsia-500/30 group-hover:bg-fuchsia-600 group-hover:text-white group-hover:border-fuchsia-500 group-hover:shadow-[0_0_20px_rgba(219,39,119,0.4)]" data-id="element-722">
              Sneak Peek
              <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-723" />
            </Link>
          </motion.div>

          {/* TTL Board Game */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="group relative bg-gradient-to-br from-indigo-950 to-slate-900 rounded-[2.5rem] p-8 shadow-xl border border-indigo-800/50 overflow-hidden flex flex-col hover:-translate-y-2 transition-transform duration-500" data-id="element-724">
            <div className="absolute inset-0 opacity-20 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-cyan-500/20 via-transparent to-transparent" data-id="element-725" />

            {/* Stylized City Graphic */}
            <div className="absolute bottom-0 inset-x-0 h-32 opacity-30 flex items-end justify-center overflow-hidden pointer-events-none" data-id="element-726">
              <div className="w-8 h-24 bg-cyan-900 mx-1 rounded-t-sm" data-id="element-727" />
              <div className="w-12 h-16 bg-indigo-900 mx-1 rounded-t-sm" data-id="element-728" />
              <div className="w-10 h-32 bg-cyan-800 mx-1 rounded-t-sm" data-id="element-729" />
              <div className="w-14 h-20 bg-indigo-800 mx-1 rounded-t-sm" data-id="element-730" />
              <div className="w-8 h-28 bg-cyan-900 mx-1 rounded-t-sm" data-id="element-731" />
            </div>

            <div className="relative z-10 mb-6" data-id="element-732">
              <div className="flex justify-between items-start mb-6" data-id="element-733">
                <div className="w-16 h-16 rounded-2xl bg-indigo-900/50 flex items-center justify-center shadow-sm border border-indigo-700/50" data-id="element-734">
                  <Gamepad2Icon className="w-8 h-8 text-cyan-400" data-id="element-735" />
                </div>
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-slate-800 text-slate-300 text-xs font-bold uppercase tracking-wider border border-slate-700" data-id="element-736">
                  <ClockIcon className="w-3 h-3" data-id="element-737" />
                  Coming Soon
                </span>
              </div>

              <h3 className="font-heading text-2xl font-bold text-white mb-3" data-id="element-738">
                TTL: The Board Game
              </h3>
              <p className="text-indigo-200/70 font-medium leading-relaxed mb-8" data-id="element-739">
                A cinematic life-simulation experience where the city itself
                becomes the game. Navigate the highs and lows of adulthood one
                move at a time.
              </p>
            </div>

            <Link to="/apps/ttl-board-game" className="relative z-10 mt-auto inline-flex items-center justify-center w-full py-4 rounded-2xl bg-indigo-900/40 text-cyan-300 font-bold hover:bg-indigo-800/60 transition-colors border border-indigo-700/50 group-hover:bg-cyan-500 group-hover:text-slate-900 group-hover:border-cyan-400" data-id="element-740">
              Sneak Peek
              <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-741" />
            </Link>
          </motion.div>
        </div>
      </div>
    </div>;
}
function ClockIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-742">
      <circle cx="12" cy="12" r="10" data-id="element-743" />
      <polyline points="12 6 12 12 16 14" data-id="element-744" />
    </svg>;
}